import React, { useEffect, useState }   from 'react';
import { Box, Container }               from '@mui/material';
import Grid                             from '@mui/material/Grid2';
import MerceDanneggiata                 from '../../components/card/MerceDanneggiata';
import MerceNonConforme                 from '../../components/card/MerceNonConforme';
import RiparazioniCard                  from '../../components/card/RiparazioniCard';
import DoaCard                          from '../../components/card/DoaCard';
import axios                            from 'axios';
import { useAvvisi }                    from '../../context/AvvisiContext';
import ApiService                       from '../../components/service/ApiService';

const ResiPage = () => {

  const [loading,         setLoading          ] = useState(true);
  const [resiNumber,      setResiNumber       ] = useState({
    riparazione:      0,
    doa:              0,
    merceDanneggiata: 0,
    merceNonConforme: 0,
  });

  const { setDatiAvvisi } = useAvvisi();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const token = user?.token;


  const idCliente = user?.idCliente;  


  //fino allo useEffect mi serve solo per i test poi verrà tolto
  const IDCustomerRMT = user?.idRiba;

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
  
    if (user) {
      const updatedUser = { ...user, IDCustomerRMT };
  
      sessionStorage.setItem("user", JSON.stringify(updatedUser));
    }
  }, []);
  

  useEffect(() => {
    const fetchRAMnumber = async () => {
      setLoading(true); 
      try {
        // const response = await axios.get(`http://localhost:8080/rma/number/${idCliente}`, { headers: headers});
        const response = await ApiService.request("numeroRMACliente", {idCliente: idCliente});
      //   const responseGetInvoiceFromCustomerID = await axios.post(
      //     "https://marvinapi-preprod.azurewebsites.net/api/SAT/GetInvoiceFromCustomerID",
      //     {},
      //     {
      //         headers: {
      //             Authorization: headers,
      //             IDCustomerRMT: idCliente,
      //         },
      //     }
      // );

      //   if (responseGetInvoiceFromCustomerID.data?.code === 200) {
      //     setCustomerData(response.data);
      // } else {
      //     console.log("la chiatama a responseGetInvoiceFromCustomerID non è andata a buon fine");
      // };


        if (response.data) {
          setResiNumber({
            riparazione:      response.data.riparazione       || 0,
            doa:              response.data.doa               || 0,
            merceDanneggiata: response.data.merceDanneggiata  || 0,
            merceNonConforme: response.data.merceNonConforme  || 0,
          });
        } else {
          console.error("I dati ottenuti non sono validi:", response.data);
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati RMA", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchRAMnumber();
  }, []);


  return (
    <Box 
      sx={{
        backgroundColor: "#f8f8f8", 
        display: 'flex',
        flexDirection: 'column', 
        justifyContent: 'center',
        width: "100%",
        boxSizing: 'border-box',
        flex: 1
      }}
    >
      <Container maxWidth='xl' sx={{ padding: 2 }}>
      <Grid container spacing={3} justifyContent="center" alignItems="stretch">
        <Grid xs={12} sm={6} md={6} lg={6}>
          <RiparazioniCard resiAperti={resiNumber.riparazione} />
        </Grid>
        <Grid xs={12} sm={6} md={6} lg={6}>
          <DoaCard resiAperti={resiNumber.doa} />
        </Grid>
        <Grid xs={12} sm={6} md={6} lg={6}>
          <MerceDanneggiata resiAperti={resiNumber.merceDanneggiata} />
        </Grid>
        <Grid xs={12} sm={6} md={6} lg={6}>
          <MerceNonConforme resiAperti={resiNumber.merceNonConforme} />
        </Grid>
      </Grid>

      </Container>
    </Box>
  );
}

export default ResiPage;
